import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import PricingSection from "@/components/PricingSection";
import AreasSection from "@/components/AreasSection";
import QuoteFormSection from "@/components/QuoteFormSection";
import Footer from "@/components/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navigation />
      <main>
        <HeroSection />
        <ServicesSection />
        <PricingSection />
        <AreasSection />
        <QuoteFormSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
